module.exports = __webpack_public_path__ + "img/three.0558c650.svg";